define("shared/utils/redirect", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = redirect;
  0; //eaimeta@70e063a35619d71f0,"@embroider/macros"eaimeta@70e063a35619d71f
  /**
   * Redirects to the provided url. Exists to allow stubbing redirects in tests
   * as you cannot easily stub `window.location.href` directly.
   * An error will be thrown is this util runs during tests.
   */
  function redirect(url) {
    let keepQueryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (false) {
      throw new Error('The redirect util should be stubbed in tests to avoid accidental redirects');
    }
    let finalUrl = url;

    // Check if we need to keep the query parameters
    if (keepQueryParams) {
      const currentQueryString = window.location.search;
      // Check if the URL already has query parameters, append using '&' if so, '?' otherwise
      const separator = url.includes('?') ? '&' : '?';
      finalUrl += currentQueryString ? separator + currentQueryString.substring(1) : '';
    }
    window.location.replace(finalUrl);
  }
});